<input #fileInput type="file" [multiple]="multiple" [attr.accept]="accept || null" style="display:none" (change)="onFileSelected($event)" />
<div class="file-dropzone"
  [class.file-dropzone--loading]="uploading"
  [class.file-dropzone--dragover]="isDragOver"
  [class.file-dropzone--disabled]="disabled"
  (click)="onDropzoneClick()"
  (dragenter)="onDragEnter($event)"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)"
  (drop)="onFilesDropped($event)">
  @if (uploading) {
    <mat-icon class="material-symbols-outlined">{{ uploadingIcon }}</mat-icon>
    <div class="file-dropzone-title">{{ uploadingLabel }}</div>
  } @else {
    <mat-icon class="material-symbols-outlined">{{ icon }}</mat-icon>
    <div class="file-dropzone-title">{{ label }}</div>
    @if (hint) {
      <div class="file-dropzone-sub">{{ hint }}</div>
    }
  }
</div>
